<div class="my-4 mx-5">
    <div class="wrapper mb-5">
        <div class="row align-items-center m-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Cartões</span>
            <button class="action-button ml-2 my-1" (click)="navigateToCartoesPedido()">Pedir Cartões</button>

        </div>
        <div class="row align-items-center m-0">
            <!-- <div class="component-box container-fluid mb-0 col-2 mt-2 mr-4">
                <div class="container-fluid p-2">
                    <div class="row align-items-center">
                        <div class="col-auto p-0">
                            <i class="fas fa-info-circle" style="font-size: 40px;"></i>
                        </div>
                        <div class="col pl-2 pr-0">
                            <p class="m-0">Ativos</p>
                        </div>
                        <div class="col py-3 px-1 text-center">
                            <h4 class="m-0">10000</h4>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="component-box container-fluid mb-0 col-sm col-md-2 mt-2 mr-4">
                <div class="container-fluid row mx-0 p-3">
                    <div class="col-md-12 align-items-center py-2 text-center">
                        <div class="col-md-12">
                            <i class="fas fa-dolly-flatbed" style="font-size: 20px; color: #111224;"></i>
                        </div>
                        <div class="col-md-12">
                            <p class="m-0">Em Estoque</p>
                        </div>
                    </div>
                    <div class="col align-self-center py-2">
                        <div class="text-center">
                            <app-number-counter [digit]="cardsData.inventoryCards" [duration]="1000"></app-number-counter>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="component-box container-fluid mb-0 col-sm col-auto  mt-2 mr-2">
                <div class="container-fluid p-2 row">
                    <div class="col-auto align-items-center py-2 px-2">
                        <div class="col text-center pl-3">
                            <i class="fas fa-search" style="font-size: 20px; color: #111224;"></i>
                        </div>
                        <div class="col">
                            <p class="m-0">Em Análise</p>
                        </div>
                    </div>
                    <div class="col align-self-center py-2 px-0">
                        <div class="text-center">
                            <app-number-counter [digit]="cardsData.inAnalysisCards" [duration]="1000"></app-number-counter>
                        </div>
                    </div>
                </div>
            </div>
            <div class="component-box container-fluid mb-0 col-sm col-auto  mt-2 mr-2">
                <div class="container-fluid p-2 row">
                    <div class="col-auto align-items-center py-2 px-2">
                        <div class="col text-center pl-3">
                            <i class="fas fa-truck-moving" style="font-size: 20px; color: #111224;"></i>
                        </div>
                        <div class="col">
                            <p class="m-0">Em Trânsito</p>
                        </div>
                    </div>
                    <div class="col align-self-center py-2 px-0">
                        <div class="text-center">
                            <app-number-counter [digit]="cardsData.inProcessingCards" [duration]="1000"></app-number-counter>
                        </div>
                    </div>
                </div>
            </div>
            <div class="component-box container-fluid mb-0 col-sm col-auto  mt-2 mr-2">
                <div class="container-fluid p-2 row">
                    <div class="col-auto align-items-center py-2 px-2">
                        <div class="col text-center pl-3">
                            <i class="fas fa-dolly-flatbed" style="font-size: 20px; color: #111224;"></i>
                        </div>
                        <div class="col">
                            <p class="m-0">Em Estoque</p>
                        </div>
                    </div>
                    <div class="col align-self-center py-2 px-0">
                        <div class="text-center">
                            <app-number-counter [digit]="cardsData.inventoryCards < 0 ? cardsData.inventoryCards*(-1) : cardsData.inventoryCards" [duration]="1000"></app-number-counter>
                        </div>
                    </div>
                </div>
            </div>
            <div class="component-box container-fluid mb-0 col-sm col-auto mt-2 mx-0">
                <div class="container-fluid p-2 row">
                    <div class="col-auto align-items-center py-2 px-2">
                        <div class="col text-center pl-3">
                            <i class="fas fa-check-circle" style="font-size: 20px; color: #111224; color: #111224;"></i>
                        </div>
                        <div class="col">
                            <p class="m-0">Em Uso</p>
                        </div>
                    </div>
                    <div class="col align-self-center py-2 px-0">
                        <div class="text-center">
                            <app-number-counter [digit]="cardsData.activeCards" [duration]="1000"></app-number-counter>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="component-box container-fluid mb-0 mt-4">
            <div class="container-fluid pt-4">
                <div class="row">
                    <div class="col-md-3 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Pedidos</h5>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-9 text-right" *ngIf="true">
                        <ul class="options-cadastro">
                            <!-- <li>
                                <div *ngIf="filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                                    my-1">
                                    <button class="list-select-delete" type="button">
                                        Apagar filtro
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div (click)="showFilter(filtro)" class="list-select ml-2
                                    my-1">
                                    <button class="list-select"  type="button">
                                        <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                        <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                                    </button>
                                </div>
                            </li> -->
                            <li>
                                <div class="list-filter-show-item ml-2 my-1">
                                    Mostrar:
                                    <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                        <option _ selected="" value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive" *ngIf="solicitations.length > 0">
                            <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <th>Número do Pedido</th>
                                    <th>Situação do Pedido</th>
                                    <th>Quantidade</th>
                                    <th>Data do Pedido</th>
                                    <th>Data de Entrega</th>
                                    <th></th>
                                </thead>
                                <tbody class="list-table-row">
                                    <tr class="list-table-cell" *ngFor="let item of solicitations | paginate: { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalSolicitations }">
                                        <td>{{item.solicitationId}}</td>
                                        <td>{{item.statusDescription}}</td>
                                        <td>{{item.quantityCards}}</td>
                                        <td>{{item.solicitationDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                                        <td *ngIf="item.deliveryDate != null">{{item.deliveryDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                                        <td *ngIf="item.deliveryDate == null">-</td>
                                        <td>
                                            <div ngbDropdown class="d-inline-block menu-option custom-context-menu-container" placement="left">
                                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                                        src="assets/icons/menu.png" /></button>
                                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                                    <section class="custom-context-menu">
                                                        <div ngbDropdownItem (click)="details(item)">
                                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />Detalhes do pedido
                                                        </div>
                                                        <div *ngIf="item.statusId === 1" ngbDropdownItem (click)="showCancel(cancelmodal,item)">
                                                            <img src="assets/icons/garbage-purple.png" class="mr-2" />Cancelar pedido
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="page-custom mt-2">
                                <pagination-controls (pageChange)="changePage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                            </div>
                        </div>

                        <div *ngIf="solicitations.length === 0" class="text-center">
                            <h6 class="py-5">
                                Nenhum pedido foi encontrado. Faça um pedido.
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Cancelar-->
<ng-template #cancelmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Cancelar pedido de cartões
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Tem certeza que deseja cancelar o pedido de código:
                <span style="color:#313840; font-weight: bold;"> {{solicitationToCancel.solicitationId}}?</span>
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">Não</button>
        <button class="custom-filter-button custom-filter-button-just" type="button" type="button" (click)="cancel(solicitationToCancel);modal.dismiss('Close click')">Sim</button>
    </div>
</ng-template>
